exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".form-popup-content{overflow-y:auto;height:100%}.error-message{display:inline-block;padding-top:10px;font-weight:700;color:#f23d4e}", ""]);

